/**
 * PluginRackPanel Component
 * Plugin Rack panel for master bus chain
 */

import React from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { Button } from '../../ui/button';
import { X, Layers, FolderOpen } from 'lucide-react';
import { PluginRack } from '../plugins';

export const PluginRackPanel = ({
  isOpen,
  onClose,
  masterPluginChain,
  setShowPluginBrowser,
  setShowChainPresets,
  handleRemoveMasterPlugin,
  handleToggleMasterPluginBypass,
  handleReorderMasterPlugins,
  handleMasterPluginParamChange,
  handleDuplicateMasterPlugin,
  handleResetMasterPlugin,
}) => {
  return (
    <AnimatePresence>
      {isOpen && (
        <motion.div
          initial={{ opacity: 0, x: 20 }}
          animate={{ opacity: 1, x: 0 }}
          exit={{ opacity: 0, x: 20 }}
          className="fixed top-0 right-0 bottom-0 w-80 z-40 bg-zinc-900/95 backdrop-blur-md border-l border-zinc-700"
        >
          <div className="flex items-center justify-between px-4 py-3 border-b border-zinc-800 bg-gradient-to-r from-violet-500/10 to-purple-500/10">
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 rounded-xl bg-gradient-to-br from-violet-500 to-purple-500 flex items-center justify-center">
                <Layers className="w-5 h-5 text-white" />
              </div>
              <div>
                <h3 className="text-sm font-semibold text-white">Plugin Rack</h3>
                <p className="text-xs text-zinc-400">Master bus chain</p>
              </div>
            </div>
            <div className="flex items-center gap-2">
              <Button
                onClick={() => setShowChainPresets(true)}
                size="sm"
                variant="ghost"
                className="h-8 px-2 text-xs text-zinc-400 hover:text-white"
                data-testid="chain-presets-btn"
                title="Chain Presets"
              >
                <FolderOpen className="w-4 h-4" />
              </Button>
              <button
                onClick={onClose}
                className="p-1 text-zinc-400 hover:text-white transition-colors"
              >
                <X className="w-5 h-5" />
              </button>
            </div>
          </div>
          <PluginRack
            plugins={masterPluginChain}
            onAddPlugin={() => setShowPluginBrowser(true)}
            onRemovePlugin={handleRemoveMasterPlugin}
            onToggleBypass={handleToggleMasterPluginBypass}
            onReorderPlugins={handleReorderMasterPlugins}
            onParameterChange={handleMasterPluginParamChange}
            onDuplicatePlugin={handleDuplicateMasterPlugin}
            onResetPlugin={handleResetMasterPlugin}
          />
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default PluginRackPanel;
